import { Component, Input, OnInit } from '@angular/core';
import { Home } from '../../interfaces/page';
import { WordpressService } from '../../services/wordpress.service';

@Component({
  selector: 'app-home-section-press',
  templateUrl: './home-section-press.component.html',
  styleUrls: ['./home-section-press.component.scss']
})
export class HomeSectionPressComponent implements OnInit {
  @Input() content: Home;

  constructor(
    private wp: WordpressService
  ) {
  }

  ngOnInit() {
  }

}
